var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconViewingAngle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "14px",
    viewBox: "0 0 26 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-viewing-angle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specs",
    transform: "translate(-352.000000, -177.000000)",
    stroke: "#010003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-viewing-angle",
    transform: "translate(353.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1.58983937e-13 C18.627417,1.58983937e-13 24,5.372583 24,12 C24,12.1676978 23.9965601,12.3345922 23.9897469,12.5006164 L17.9793885,12.5009037 C17.993039,12.3357427 18,12.1686843 18,12 C18,8.6862915 15.3137085,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,12.1686843 6.00696103,12.3357427 6.02061151,12.5009037 L0.0102530691,12.5006164 C0.00343992728,12.3345922 0,12.1676978 0,12 C0,5.372583 5.372583,1.58983937e-13 12,1.58983937e-13 Z",
    id: "Combined-Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewingAngle);
export default __webpack_public_path__ + "static/media/icon-viewing-angle.411bf3691f3fa17043423ad0979f8513.svg";
export { ForwardRef as ReactComponent };